const MAX_LENGTH = 255;
const LIMIT_FILE_SIZE = 3000000;

export { MAX_LENGTH, LIMIT_FILE_SIZE };
